import API_URLS from '../../constants/api-urls';
import { FOLDER_DIRECTORIES } from '../../constants/folder';
import { world } from '../../languages';
import axios from '../../utils/axios';

export const deleteFolder = ({ directory, id }: { directory: FOLDER_DIRECTORIES; id: number }) => {
    const queryFilter = `{ type: ${directory}, id: ${id}, world: "${world}" }`;

    return axios.post(API_URLS.FOLDERS.DELETE, {
        queryFilter
    });
};
